import { render, staticRenderFns } from "./AddressPicker.vue?vue&type=template&id=2956defd&scoped=true&"
import script from "./AddressPicker.vue?vue&type=script&lang=js&"
export * from "./AddressPicker.vue?vue&type=script&lang=js&"
import style0 from "./AddressPicker.vue?vue&type=style&index=0&id=2956defd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2956defd",
  null
  
)

export default component.exports